/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Choose_Your_LanguageInputs */

const en_nav_choose_your_language = /** @type {(inputs: Nav_Choose_Your_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a language`)
};

const fr_nav_choose_your_language = /** @type {(inputs: Nav_Choose_Your_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez une langue`)
};

/**
* | output |
* | --- |
* | "Choose a language" |
*
* @param {Nav_Choose_Your_LanguageInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const nav_choose_your_language = /** @type {((inputs?: Nav_Choose_Your_LanguageInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Choose_Your_LanguageInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_choose_your_language(inputs)
	return fr_nav_choose_your_language(inputs)
});